import { FirebaseStorage, getStorage } from 'firebase/storage';
import { useFirebaseApp } from './useFirebaseApp';
import { useMemo } from 'react';

const useFirebaseStorage = (bucketUrl: string): FirebaseStorage => {
  const firebase = useFirebaseApp();
  return useMemo(() => getStorage(firebase, bucketUrl), [firebase, bucketUrl]);
};

export const useFirebaseUploadStorage = (): FirebaseStorage => {
  return useFirebaseStorage(
    `gs://${__JS_ENV_VARS__['JS_ENV_FIREBASE_UNSCANNED_STORAGE_BUCKET']}`,
  );
};

export const useFirebaseCleanStorage = (): FirebaseStorage => {
  return useFirebaseStorage(
    `gs://${__JS_ENV_VARS__['JS_ENV_FIREBASE_STORAGE_BUCKET']}`,
  );
};
